import React, { useState } from 'react';
import EditButton from '../editButton';
import formatter from "../../../../../../utils/formatter";
import { AlertMessagePrimary, AlertMessage } from '../popup';
import { StepperHoverTitle } from '../stepper/styles';
import { initiateTracking, recordError } from '../../../../../../utils/commonUtil';
import {ScheduleType as ScheduleTypeConstants} from '../../constants';

const Info = (props) => {
    const { history, totalAmount, stepData, id, isDirty, location, scheduleType } = props;
    const [warn, setWarn] = useState(false);
    const navigate = () => {
        history.push({
            pathname: `/investments/recommend-an-exchange/${id}/to`,
            state: {
                prev: location
            }
        })
    }
    const handleEdit = (e) => {
        try {
            const scheduleTypeLabel = scheduleType === ScheduleTypeConstants.onetime ? 'One Time Exchange' : 'Recurring Exchange';
            const currentLocation = location.pathname === '/investments/recommend-an-exchange/NEW/to' ? 'Step 2 Recommend exchange to' : 'Step 3 Review exchange and submit';
            initiateTracking('edit', 'Recommend An Exchange', currentLocation, `Edit - ${scheduleTypeLabel} - Step 2 Recommend exchange to - Stepper`);
            if(isDirty) {
                setWarn(true);
            } else {
                navigate();
            }
        } catch (error) {
          recordError(error);
        }
    };
    const handleResponse = (isContinue) => {
        setWarn(false);
        if (isContinue) {
            navigate();
        }
    }
    return (
        <div className='flex items-center'>
            <div>
                <StepperHoverTitle>Recommend exchange to</StepperHoverTitle>
                <div>Estimated exchange amount: {formatter({ value: totalAmount, fieldSuffix: "Dollars" })}</div>
                <div>Into: {stepData.pools.length} Investment Pool(s)</div>
            </div>
            <EditButton onClick={handleEdit}></EditButton>
            <AlertMessagePrimary                
                title='Alert'
                visible={warn}
                onCancel={(e) => handleResponse(false)}
                onOk={(e) => handleResponse(true)}
            >
                Changing the step might result in loss of data entered so far.
                Are you sure you want to continue?
            </AlertMessagePrimary>
        </div>
    )
}
export default Info;